import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const Logistique = () => {
  const sectorData = {
    title: "Logistique",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Les prestataires logistiques, TMS, WMS ou transporteurs doivent cibler les supply chain managers avec des références chiffrées. Proposer des audits flux, des simulateurs de coûts ou des cas clients permet de structurer leur différenciation.",
    name: "Logistique/Transport",
    titleContext: "du secteur de la logistique",
    responseContext: "du secteur des logisticiens",
    expertContext: "du secteur des logisticiens"
  };

  return <SectorPage sector={sectorData} />;
};

export default Logistique; 